import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { PossibleTag } from '@/components/ui/Tag/PossibleTag';
/**
 * 「プロジェクトで求めていること」で利用する利用可否タグ群
 * @param props
 * @constructor
 */
export const RfpProfessionalRequiredConditionPossibleGroupTag = (props) => {
    const { className = '', items: propItems } = props;
    // warning回避のためにkeyを付与
    const items = useMemo(() => propItems.map((v, key) => (Object.assign(Object.assign({}, v), { key }))), [propItems]);
    return (_jsx("div", Object.assign({ className: clsx('flex flex-nowrap gap-x-12 w-full', className) }, { children: items.map((v) => (_jsx(PossibleTag, Object.assign({ className: 'w-1/3 whitespace-nowrap', isPossible: v.isPossible }, { children: v.label }), v.key))) })));
};
